import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SideBarState {
  menu_data: string | number | Array;
}

const initialState: SideBarState = {
  menu_data: [],
};

const sideBarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setMenuData: (state, action: PayloadAction<string | number>) => {
      state.menu_data = action.payload;
    },

  },
});

export const { setMenuData } = sideBarSlice.actions;
export default sideBarSlice.reducer;
